const { browser, os } = require('ua-parser-js')();

const majorVersion = Number.parseInt(browser.version.split('.')[0]);

// mobile safari가 12 이하 버전일 때 body element에 safari_under_13 class 추가
if (browser.name === 'Mobile Safari' && majorVersion < 13) {
  document.body.classList.add('is_safari_under_13');
};
// just mobile safari
if (browser.name === 'Mobile Safari') {
  document.body.classList.add('is_safari');
};
//whale 대응
if(browser.name === 'Whale') {
  document.body.classList.add('is_whale')
}
//검색창 안드로이드만 애니메이션 추가하기 위해 os 확인
if(os.name === 'Android') {
  document.body.classList.add('is_android');
}
if(os.name === 'iOS' && browser.name === 'Chrome') {
  document.body.classList.add('is_ios_chorme');
}
